import { OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ConfigService } from '../services/config/config.service';

export function createOktaConfig(configService: ConfigService): OktaConfig {
  // `config` throws ConfigNotLoadedError if the sync preload failed entirely;
  // this guard covers a config that loaded but is missing the oktaConfig block.
  const okta = configService.config.oktaConfig;
  if (!okta) {
    throw new Error('Missing oktaConfig in runtime config (adminPortalConfig.oktaConfig)');
  }

  return {
    oktaAuth: new OktaAuth({
      issuer: okta.issuer,
      clientId: okta.clientId,
      redirectUri: okta.redirectUri,
      scopes: okta.scopes,
      pkce: okta.pkce,
      // AuthService.initialize() owns the post-login token exchange and App
      // drives navigation via authSuccess, so suppress Okta's own redirect
      // (the default does a full window.location.replace).
      restoreOriginalUri: async () => {},
    }),
  };
}
